import './selectMachineCategory.css'

import React, { useState } from "react"
import { MachineTypesRepository } from "../../services/repository/machineTypes"
import { Services } from "@/services/services"
import { CurrentSession } from "@/services/repository/session"
import { useTranslations } from "@/hooks/useTranslations"
import { useAppContext } from '@/context/app'

export interface Props {
  onSelect: (categoryName: string, item: string) => void
  onClose: () => void
}

export const CategoryItemSelectPopup: React.FC<Props> = ({
  onClose,
  onSelect
}) => {
  const { services, session, translates } = useAppContext()
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  const [selectedItem, setSelectedItem] = useState<string | null>(null)

  const categories = services.machineTypes.categories()

  // Show category list first
  if (!selectedCategory) {
    return <div className="category-item-select-popup">
      {/* <button className="popup-close" onClick={onClose}>×</button> */}
      <h2>{translates?.for('popup.category_item_select.select_category_title')}</h2>
      <ul>
        {categories.map(cat => (
          <li key={cat.name} className="popup-category-btn"
            onClick={() => setSelectedCategory(cat.name)}>
            {translates?.for('machine.types_categories.' + cat.name)}
          </li>
        ))}
      </ul>
    </div>
  }

  // Show item list after category selected
  const cat = services.machineTypes.category(selectedCategory)
  if (!cat) {
    onClose()
    return null
  }

  return <div className="category-item-select-popup">
    {/* <button className="popup-close" onClick={onClose}>×</button> */}
    <button className="popup-back" onClick={() => {
      setSelectedCategory(null)
      setSelectedItem(null)
    }}>← {translates?.for('popup.category_item_select.back')}</button>
    <h2>
      {translates?.for('machine.types_categories.' + selectedCategory)}
    </h2>
    <ul>
      {cat.items.map(item => (
        <li key={item} className={`popup-item-btn ${selectedItem === item ? "selected" : ""}`}
          onClick={() => {
            if(!item) {
              return
            }
            onSelect(selectedCategory, item)
            onClose()
          }}>
          {translates?.for('machine.types.' + item)}
        </li>
      ))}
    </ul>
  </div>
}